// Interfaces sugeridas para los filtros
// interface Categoria { id: string; nombre: string; }
// interface Proveedor { id: string; nombre: string; [key: string]: any }
// interface TipoProducto { id: string; nombre: string; [key: string]: any }

export default {
  filtros: {
    categorias: [], // [{ id: string, nombre: string }]
    merchants: [], // [{ id: string, nombre: string, ... }]
    tipoProductos: [] // [{ idSubProducto: string, descripcion: string, moneda: string, ... }]
  },
  convenios: {
    data: [], // [{ idEmpresa, nombreEmpresa, categoriaEmpresa, tipoProducto }]
    paginas: 1,
    registros: 0
  }
};
